import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import ReactDOM from 'react-dom';
import {Loader} from "@googlemaps/js-api-loader";
import Autocomplete from "./Autocomplete";
import QuickFilter from "./QuickFilter";
function Map({data, googleMapKey, updateBounds, updateHasAutocomplete, inputRef, setShowFilter, showFilter, gammes, categories, removeActiveGamme, removeActiveCategory}) {

    const [googleMap, setGoogleMap] = useState(null);
    const [markers, setMarkers] = useState([]);
    const [places, setPlaces] = useState({});
    const [map, setMap] = useState(null);
    const [infoWindow, setInfoWIndow] = useState(null);


    let style = {
        'height': '800px'
    };

    const icon = {
        path:"M12 18.4778C8.38538 18.4778 5.45505 15.4601 5.45505 11.7377C5.45505 8.01456 8.38538 4.99685 12 4.99685C15.6146 4.99685 18.545 8.01456 18.545 11.7377C18.545 15.4601 15.6146 18.4778 12 18.4778ZM18.5112 0H5.48954C2.45781 0 0 2.53039 0 5.65253V16.7395C0 17.8775 0.33456 18.9893 0.957461 19.9284L7.3341 29.5371C8.35709 31.0786 10.0527 32 11.8655 32H12.1345C13.9473 32 15.6429 31.0786 16.6659 29.5371L23.0425 19.9284C23.6661 18.9893 24 17.8775 24 16.7395V5.65253C24 2.53039 21.5422 0 18.5112 0Z",
        scale: 1,
        fillOpacity: 1,
        fillColor:"#801655",
        strokeOpacity:0
    }
    const placeChanged = (placesChanged) => {
        if (placesChanged.length == 0) {
            return false;
        }
        setPlaces(placesChanged);
    }

    const loader = useMemo(() => {
        return new Loader({
            apiKey: googleMapKey,
            version: "weekly",
            libraries: ["places"]
        });
    }, [googleMapKey])


    const mapOptions = {
        center: {
            lat: 49.0372818,
            lng: 1.9754934
        },
        zoom: 8,
        mapTypeControl: false,
    };

    const styles = {
        default: [],
        hide: [
            {
                featureType: "poi.business",
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "transit",
                elementType: "labels.icon",
                stylers: [{ visibility: "off" }],
            },
        ],
    };


    let mapRef = useRef(null);

    const initMarkers = function() {
        let googleMarkers = []
        data.map(function(item) {
            let cords = item.location.latlng.split('|');
            var markerIcon = { ...icon };

            if(item.shop_categories.length > 0) {
                markerIcon.fillColor = item.shop_categories[0].color;
            }
            var marker = new googleMap.maps.Marker({
                position: { lat: parseFloat(cords[0]), lng: parseFloat(cords[1])},
                icon:markerIcon,
                map
            });


            marker.set('id', item.id);
            marker.set('title', item.title);
            marker.set('location', item.location.address);
            marker.set('gammes', formattedGammes(item));
            googleMarkers[item.id] = marker;

            marker.addListener("click", () => {
                infoWindow.setContent(`<div class="distributor-container"><div class="title">${marker.title}</div><br/><div class="location">${marker.location}</div><div class="gammes">${marker.gammes}</div></div>`)
                infoWindow.open({
                    anchor: marker,
                    map,
                    shouldFocus: false,
                });
            });

        });
        setMarkers(googleMarkers);
    }

    const formattedGammes = function(item) {
        return item.product_categories.map(function(gamme) {
            return gamme.title
        }).join(', ');
    }

    useEffect(() => {
        if(mapRef.current) {
            loader
                .load()
                .then(() => {
                    setGoogleMap(google);
                    var map = new googleMap.maps.Map(mapRef.current, mapOptions);
                    map.setOptions({ styles: styles["hide"] })
                    setMap(map);
                })
                .catch(e => {
                    // do something
                });
        }
    }, [mapRef.current])

    useEffect(() => {
        if(markers.length > 0) {
            markers.forEach(function(marker) {
                var find = data.find(element => element.id === marker.id);;
                find ? marker.setVisible(true) :  marker.setVisible(false);
            });
        }
    }, [data, markers])


    useEffect(() => {
        if(places.address_components) {
            var bounds = new googleMap.maps.LatLngBounds();
            bounds.extend(places.geometry.location);
            map.fitBounds(bounds);
            map.setZoom(13);
            var test = markers.filter(function(marker) {
                console.log(bounds+' '+marker.position);
                return map.getBounds().contains(marker.getPosition())
            })
            updateBounds(test);
        }
    }, [places, markers, googleMap, map])


    useEffect(() => {
        if(map) {
            initMarkers();
        }
    }, [map])

    useEffect(() => {
        if(googleMap) {
            setInfoWIndow(new googleMap.maps.InfoWindow({
                content: "",
            }));
        }
    }, [googleMap])


    return (<div>
        <div className="autocomplete-container">
            {!showFilter &&
            <button className="filter-button" onClick={(e) => {
                e.preventDefault();
                setShowFilter(true);
            }}>Filtres</button>
            }
            <Autocomplete showFilter={showFilter} inputRef={inputRef} googleMap={googleMap} map={map} placeChanged={placeChanged} updateHasAutocomplete={updateHasAutocomplete}/>
        </div>
        {!showFilter &&
            <QuickFilter gammes={gammes} categories={categories} removeActiveGamme={removeActiveGamme} removeActiveCategory={removeActiveCategory}/>
        }
        <div ref={mapRef} style={style} id="map">
        </div>
    </div>)
}

export default Map;
